<template>
  <div class="animated fadeIn">
    <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;" >
      <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;" >
        <img class="navbar-brand-full" src="/static/img/preload.gif" />
      </div>
    </div>
    <b-row>
      <b-col sm="12" lg="4">
        <location-add-form></location-add-form>
      </b-col>
      <b-col sm="12" lg="8">
        <b-card :header="caption">
          <b-table
            ref="table"
            :no-provider-paging="true"
            :hover="true"
            :striped="false"
            :bordered="false"
            :small="false"
            :fixed="true"
            responsive="sm"
            :items="locations"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
          >
            <template slot="description" slot-scope="data">{{data.item.description}}</template>
            <template slot="action" slot-scope="data">
              <div style="width:126px;">
                <b-button
                  type="button"
                  variant="primary"
                  @click.stop="addFavourite(data.item.id)"
                  style="float:left; margin-right:5px; margin-bottom:12px;"
                >
                  <div v-if="favLocId != data.item.id">
                    <i class="fa fa-star-o"></i>
                  </div>
                  <div v-if="favLocId == data.item.id">
                    <i class="fa fa-star" style="color:orange;"></i>
                  </div>
                </b-button>
                <b-button
                  type="button"
                  variant="primary"
                  @click.stop="showModal(modalId(data.item.id), $event.target)"
                  style="float:left; margin-right:5px; margin-bottom:12px;"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button
                  type="button"
                  variant="danger"
                  @click.stop="showModal(modalDeleteId(data.item.id), $event.target)"
                  style="margin-bottom:12px;"
                >
                  <i class="fa fa-trash-o"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="getRowCount(locations)"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </b-col>
      <div v-for="location in locations" :key="location.id">
        <b-modal
          ok-only
          ok-variant="secondary"
          ok-title="Cancel"
          :id="modalId(location.id)"
          centered
        >
          <location-form :passedLocation="location" :editModalId="modalId(location.id)"></location-form>
        </b-modal>

        <b-modal
          :id="modalDeleteId(location.id)"
          @ok="handleOk(location.id, modalId(location.id), $event.target)"
          centered
        >
          <div class="modal-window">
            <div class="alert alert-danger">
              <ul class="fa-ul" style="margin-bottom: 0px;">
                <li>
                  <i class="fa fa-info-circle fa-li"></i>
                  <p>
                      Are you sure you want to delete the selected location:
                    <br />
                    <strong>{{ location.name }}</strong> ?
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </b-modal>
      </div>
    </b-row>
  </div>
</template>

<script>
import LocationAddForm from "./LocationAddForm";
import LocationForm from "./LocationForm";

let qs = require("qs");
const constants = require("./shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
const API = BASE + "/api/locations/simpleList";
const API_DELETE = BASE + "/api/locations/delete";

function postdata(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      accessToken: data.accessToken
    },
    method: "POST"
  }).then(res => res.json());
}

async function getData() {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem("token")
  };
  let res = await postdata(API, parameters);
  return res.locations;
}

async function deleteLocation(locationId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem("token"),
    locationId: locationId // don not use locationId from localstorage
  };
  let res = await postdata(API_DELETE, parameters);
  return res.location;
}

export default {
  name: "location",
  components: {
    LocationAddForm,
    LocationForm
  },
  props: {
    caption: {
      type: String,
      default: "Location"
    }
  },
  data: () => {
    return {
      owner: null,
      favLocId: "",
      locations: [],
      locationsOrigin: [],
      fields: {
        name: {
          label: "Name"
        },
        description: {
          label: "Description"
        },
        action: {
          label: "Action"
        }
      },
      currentPage: 1,
      perPage: 5,
      // pageOptions: [5, 10, 15],
      totalRows: 0,
      filter: null,
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem("token"),
        locationId: -1,
        name: "",
        oldName: "",
        description: ""
      }
    };
  },
  mounted() {
    this.$data.favLocId = localStorage.getItem("favLocation");
    let localLocationsList = localStorage.getItem("localLocationsList");

    if (localLocationsList === null || localLocationsList === "undefined") {
      getData().then(response => {
        let favLocation = localStorage.getItem("favLocation");
        if (favLocation) {
          var args = Array.from(response);
          args = this.sortLocation2() //favLocation, args, args);
          this.$data.locations = args;
        } else {
          this.$data.locations = response;
        }
        localStorage.setItem('localLocationsList', JSON.stringify(this.locations))
        this.owner = response[0].owner
        this.$data.locationsOrigin = response; // keep the latest list based from result of API
        document.getElementById("cover").style.display = "none";
        let locationId = localStorage.getItem("locationId");
        if (locationId == null && response.length > 0) {
          localStorage.setItem("locationId", response[0].id);
          localStorage.setItem("owid", response[0].owner.id);
        }
      });

    } else {
      this.$data.locations = JSON.parse(localLocationsList);
      let location = this.$data.locations.find(loc => loc.owner != null)
      if (location) {
        this.owner = location.owner
      }
      var args = Array.from(this.locations);
      args = this.sortLocation2() //this.$data.favLocId, args, args);
      this.locations = args
      this.$root.$emit("locations", args); // render location placeholder
      document.getElementById("cover").style.display = "none"
    }

    // this.$root.$on("locations", locationList => {
    //   this.locations = locationList
    //   this.locationsOrigin = locationList;
    // });

    this.$root.$on("addLocation", value => {
      value.lockgroups = []
      value.totalLocks = 0
      value.totalEkeys = 0
      value.totalPasscode = 0
      value.owner = this.owner
      var localLocations = JSON.parse(localStorage.getItem('localLocationsList'))
      localLocations.push(value)
      localStorage.setItem('localLocationsList', JSON.stringify(localLocations))
      this.locations = this.sortLocation2()
    });

    this.$root.$on("editLocation", value => {
      var localLocations = JSON.parse(localStorage.getItem('localLocationsList'))
      var index = localLocations.findIndex(loc => loc.id == value.id)
      localLocations[index].name = value.name
      localLocations[index].description = value.description
      localStorage.setItem('localLocationsList', JSON.stringify(localLocations))
      this.locations = this.sortLocation2()
    });

    // this.$root.$on("locationsOrigin", test => {
    //   alert(2)
    //   // alert('locationsOrigin '  + JSON.stringify(locationsOrigin))
    //   // this.locationsOrigin = locationsOrigin;
    // });
  },
  methods: {
    submitDataEdit(locationId) {
      this.$data.locationId = locationId;
    },
    modalId(i) {
      return "modal" + i;
    },
    mailto(email) {
      return "mailto:" + email;
    },
    modalDeleteId(i) {
      return "modaldeletelocation" + i;
    },
    details(link) {
      location.href = link;
    },
    getRowCount(items) {
      return items.length;
    },
    handleOk(id, modalId, button) {
      deleteLocation(id).then(response => {
        let index = this.$data.locations.findIndex(location => location.id == id)
        this.$data.locations.splice(index, 1)
        localStorage.setItem('localLocationsList', JSON.stringify(this.$data.locations))

        let localLocksList = localStorage.getItem('localLocksList')
        localLocksList = JSON.parse(localLocksList)

        localLocksList = this.deleteLocations(id, localLocksList)
        localStorage.setItem('localLocksList', JSON.stringify(localLocksList))

        var args = Array.from(this.$data.locations);
        args = this.sortLocation2()
        this.$root.$emit("bv::hide::modal", modalId, button);
      });
    },
    showModal(id, button) {
      this.$root.$emit("bv::show::modal", id, button);
    },
    addFavourite(locId) {
      localStorage.setItem("favLocation", locId);
      localStorage.setItem("locationId", locId);

      this.favLocId = locId;
      var args = this.sortLocation2()
      // this.$root.$emit("locations", args); // render location placeholder
      localStorage.setItem('localLocationsList', JSON.stringify(args))
      this.locations = args
      this.$refs.table.refresh(); // refresh current table without calling to API so that the favourite check will rechecked
    },
     deleteLocations(locId, list) {
      return list.reduce((arr, current) => {
      if (current.locationId == locId) {
        current.locationId = null;
        current.location = null;
      }
      arr.push(current);
      return arr;
    }, []);
},
    sortLocation2() {     
      let favLocation = JSON.parse(localStorage.getItem("favLocation"))
      var sorting = JSON.parse(localStorage.getItem("localLocationsList"))
      sorting.sort((a, b) => a.name.localeCompare(b.name));
      if (favLocation > 0) {
        var index = sorting.findIndex(x => {
          return x.id == favLocation;
        });
        if (index > 0) {
          var data = sorting[index]
          sorting.splice(index, 1)
          sorting.splice(0,0,data)
        }
      }
      this.$root.$emit("locations", sorting);
      localStorage.setItem('localLocationsList', JSON.stringify(sorting))
      return sorting;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/Location.vue